import { useStyles } from "./styles";

import { TextInput } from "@mantine/core";
import { TextInputComponentProps } from "./types";

export function TextInputComponent(props: TextInputComponentProps) {
  const { classes } = useStyles();
  const {
    label,
    required,
    placeholder,
    value,
    disabled,
    radius,
    rightSection,
    rightSectionWidth,
    icon,
    style,
    onChange,
  } = props;

  return (
    <TextInput
      placeholder={placeholder ?? "Type here..."}
      style={style}
      classNames={classes}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      disabled={disabled}
      icon={icon}
      rightSectionWidth={rightSectionWidth}
      rightSection={rightSection}
      radius={radius ?? 12}
    />
  );
}
